<template>
<transition name="modal">
    <div class="background" @click="$emit('close')">
    <dialog open>
        <header>
            <slot name="header">
                <h2>{{title}}</h2>
            </slot>
        </header>
        <section>
            <slot></slot>
        </section>
        <menu>
            <slot name="actions">
            <!-- <button @click="$emit('close')">Close</button> -->
            </slot>
        </menu>
    </dialog>
    </div>
</transition>
</template>

<script>
    export default {
        props: {
            title: {
                type:String,
                required: false,
            },
        },
        emits: ['close']
    }
</script>

<style scoped lang="scss">
.background {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
//   background-color: rgba(0, 0, 0, 0.75);
//   opacity: 30%;
  z-index: 10;
  font-family: $font-family;
}

dialog {
  position: fixed;
  top: 20vh;
  left: 10%;
  width: 80%;
  z-index: 100;
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0;
  margin: 0;
  overflow: hidden;
}

header {
  padding-left: 58px;
  font-size: 12pt;
  font-weight: 400;
  color: #222;
  background: darken($color-sidebar, 2%);
  width: 100%;
  padding: 1rem;
  
}

header h2 {
  margin: 0;
}

section {
  padding: 1rem;
}

menu {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  margin: 0;
}

@media (min-width: 200px) {
  dialog {
    left: calc(50% - 20rem);
    width: 40rem;
  }
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>